var dbHAL = {
  /**
   * 当前数据结构区分平台(Android、browser、ios)
   * 但当前系统暂不区分平台，都采用用brower平台代码逻辑
   * 如果以后要针对各平台分别处理的话，分两步走，一写各个平台的具体方法，二在APP.vue里面设置平台
   *
   * PS: 由于现阶段存储策略为,
   * 		 运行时状态存储至store,
   * 		 长久状态存储至LocalStorage,
   * 		 故平台设置为browser.
   *
   * PS2: 存储结构为键值对(key-value)存储.
   *
   */
  platform: 'browser', // 当前系统暂不区分平台，都采用用brower平台代码逻辑
  platforms: {
    android: {
      set: function (key, value) { },
      get: function (key) { },
      remove: function (key) { },
      clear: function () { },
      restore: function () { }
    },
    browser: {
      set: function (key, value) {
        localStorage.setItem(key, value)
      },
      get: function (key) {
        return localStorage.getItem(key)
      },
      remove: function (key) {
        localStorage.removeItem(key)
      },
      clear: function () {
        localStorage.clear()
      },
      /**
       * 用户退出时，清空localstorage里用户相关的数据
       * 注意：以后需要加一个users，键为useroid，值为json化的所有用户数据，希望在切换用户后依旧能存储用户数据
       */
      restore: function () {
        dbHelper.remove('token') // 用户token
        dbHelper.remove('expire') // 用户token有效期
        dbHelper.remove('tid') // 当前焦点租户 // modify by ydr 2020-06-04
        dbHelper.remove('tname') // 当前焦点租户 // modify by ydr 2020-06-04
        dbHelper.remove('flowListScrollTop') // 列表页面滚轮位置 用于页面的回退定位（读取后需要清0）
        dbHelper.remove('flowListRecordCount') // 列表页面查询记录数 用于页面的回退刷新（读取后需要清0）
        dbHelper.remove('taskListScrollTop') // 列表页面滚轮位置 用于页面的回退定位（读取后需要清0）
        dbHelper.remove('taskListRecordCount') // 列表页面查询记录数 用于页面的回退刷新（读取后需要清0）
        dbHelper.remove('haveResetPwd') // 是否已经重新密码过的标识（用于是否重置密码）
      },
      /**
       * 切换租户时，清空localstorage里用户相关的数据
       * 注意：以后需要加一个users，键为useroid，值为json化的所有用户数据，希望在切换用户后依旧能存储用户数据
       */
      restoreForChangeTenant: function () {
        dbHelper.remove('flowListScrollTop') // 列表页面滚轮位置 用于页面的回退定位（读取后需要清0）
        dbHelper.remove('flowListRecordCount') // 列表页面查询记录数 用于页面的回退刷新（读取后需要清0）
        dbHelper.remove('taskListScrollTop') // 列表页面滚轮位置 用于页面的回退定位（读取后需要清0）
        dbHelper.remove('taskListRecordCount') // 列表页面查询记录数 用于页面的回退刷新（读取后需要清0）
      },
    },
    ios: {
      set: function (key, value) { },
      get: function (key) { },
      remove: function (key) { },
      clear: function () { },
      restore: function () { }
    }
  }
}

/**
 * 数据库工具类
 */
var dbHelper = {
  /**
   * 存储数据
   */
  set: dbHAL.platforms[dbHAL.platform].set,

  /**
   * 获取数据
   */
  get: dbHAL.platforms[dbHAL.platform].get,

  /**
   * 删除数据
   */
  remove: dbHAL.platforms[dbHAL.platform].remove,

  /**
   * 清空数据
   *
   * PS: 慎用, 各类数据(如, 账号记忆、工地部位记忆等)都会被清空
   */
  clear: dbHAL.platforms[dbHAL.platform].clear,

  /**
   * 恢复初始设置
   *
   * PS: 该操作自己选择删除的数据, 以达到初始化LocalStorage的作用(长久记忆不清除)
   */
  restore: dbHAL.platforms[dbHAL.platform].restore,
  /**
   * 切换租户时，恢复部分初始设置
   *
   * PS: 该操作自己选择删除的数据, 以达到初始化LocalStorage的作用(长久记忆不清除)
   */
  restoreForChangeTenant: dbHAL.platforms[dbHAL.platform].restoreForChangeTenant,
}

export default dbHelper
